import { render } from "./AncillaryMeeting.vue?vue&type=template&id=01aafef8&ts=true"
import script from "./AncillaryMeeting.vue?vue&type=script&lang=ts"
export * from "./AncillaryMeeting.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__